import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import InfoRow from "./InfoRow.tsx";

import { CondenserData } from "../ProjectDetails.types.tsx";

import { SubHeaderLabel } from "../../Labels.tsx";

const CondenserDataCard: React.FC<{ condenserData: CondenserData }> = ({ condenserData }) => {
  const { t } = useTranslation();

  const { ambiance_temperature, altitude, min_operating_temperature, max_operating_temperature } =
    condenserData || {};

  return (
    <Card className="border-0 h-100">
      <Card.Body className="d-flex flex-column">
        <SubHeaderLabel textAlign="left" className="mb-2">
          {t("projectDetails.condenserDataCard.title")}
        </SubHeaderLabel>

        <div className="flex-grow-1">
          <InfoRow
            label={`${t("projectDetails.condenserDataCard.ambianceTemperature")}:`}
            value={ambiance_temperature}
          />
          <InfoRow label={`${t("projectDetails.condenserDataCard.altitude")}:`} value={altitude} />
          <InfoRow
            label={`${t("projectDetails.condenserDataCard.minOperatingTemp")}:`}
            value={min_operating_temperature}
          />
          <InfoRow
            label={`${t("projectDetails.condenserDataCard.maxOperatingTemp")}:`}
            value={max_operating_temperature}
          />
        </div>
      </Card.Body>
    </Card>
  );
};

export default CondenserDataCard;
